import { Component } from '@angular/core';
import { Message } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DadosDespesasFormComponent } from '../dados-despesas-form/dados-despesas-form.component';
import {
  deleteExpenses,
  editExpenses,
  loadExpenses,
} from 'src/app/store/expenses/expenses.actions';
import { Store } from '@ngrx/store';
import { IExpensesState } from 'src/app/store/expenses/expenses.reducer';
import { loadTypeExpenses } from 'src/app/store/type-expenses/type-expenses.actions';
import { selectTypeExpensesLista, selectTypeExpensesLoading } from 'src/app/store/type-expenses/type-expenses.selectors';
import { selectExpensesLista } from 'src/app/store/expenses/expenses.selectors';
import { IExpenses } from 'src/app/shared/interfaces/expenses/iexpenses';
import { ITypeExpenses } from 'src/app/shared/interfaces/expenses/itypeExpenses';

@Component({
  selector: 'app-dados-despesas',
  templateUrl: './dados-despesas.component.html',
  styleUrls: ['./dados-despesas.component.scss'],
})
export class DadosDespesasComponent {
  selectedId: number = 999999999999
  mostrarModalDeletar = false
  mostrarModalInativar = false
  mostrarModalAtivar = false
  currentExpense: any
  messages: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail:
        'Preencha essas informações pela primeira vez e salve as suas preferências. ',
    },
  ];

  listaTypeExpense$ = this.store.select(selectTypeExpensesLista);
  listaExpense$ = this.store.select(selectExpensesLista);
  isLoading$ = this.store.select(selectTypeExpensesLoading)

  constructor(
    public dialogService: DialogService,
    private store: Store<IExpensesState>
  ) {}
  ref: DynamicDialogRef | undefined;

  ngOnInit(): void {
    this.store.dispatch(loadExpenses());
    this.store.dispatch(loadTypeExpenses());
  }

  public showForm(item: ITypeExpenses) {
    //console.log('item: ', item)
    this.ref = this.dialogService.open(DadosDespesasFormComponent, {
      header: item.name,
      dismissableMask: true,
      width: '45%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      data: {
        idTypeExpense: item['@id'],
      },
    });
  }

  editCard(item: IExpenses, id: number | undefined) {
    this.ref = this.dialogService.open(DadosDespesasFormComponent, {
      header: 'Editar despesa',
      dismissableMask: true,
      width: '45%',
      contentStyle: { overflow: 'auto' },
      data: {
        item: item,
        idTypeExpense: id,
      },
      baseZIndex: 10000,
    });
  }

  deleteCard(id: number) {
    this.selectedId = id
    this.mostrarModalDeletar = true
    //this.store.dispatch(deleteExpenses({ id: id }));
  }

  deleteCardDelete(){
    this.store.dispatch(deleteExpenses({ id: this.selectedId }));
    this.fecharDialog()
  }

  public fecharDialog() {
    this.ref?.destroy()

    this.mostrarModalDeletar = false
    this.mostrarModalInativar = false
    this.mostrarModalAtivar = false
  }

  inactiveExpense(item: any){
    this.currentExpense = item
    this.mostrarModalInativar = true
  }

  patchIsActiveExpense(){
    let req = {...this.currentExpense}
    req.isActive = !req.isActive

    this.store.dispatch(editExpenses({expenses: req, id: req.id}))
    this.fecharDialog()
  }

  activeExpense(item: any){
    this.currentExpense = item
    this.mostrarModalAtivar = true

  }

}
